import { IRoute } from "../../interfaces/others/IRoute";
import { isBranchConstrained } from "../../auth/sessionAccess.ts";

export function incidentMenuTo(
  session: { grantsAll?: boolean; branchId?: number | null } | null | undefined,
) {
  return isBranchConstrained(session) ? "/sucursal/incidencias" : "/incidencias";
}

export const Routes: IRoute[] = [
  {
    name: "Solicitudes",
    to: "/solicitudes",
    activeKey: "solicitudes",
    requiredPermission: "applications.view",
    icon: "rectangle-list",
  },
  {
    name: "Colaboradores",
    to: "/colaboradores",
    activeKey: "colaboradores",
    requiredPermission: "partners.view",
    icon: "people-group",
    children: [
      {
        name: "Suspendidos",
        to: "/colaboradores/suspendidos",
        activeKey: "colaboradores-suspendidos",
        requiredPermission: "partners.view",
        icon: "user-slash",
      },
      {
        name: "Control de bajas",
        to: "/colaboradores/control-bajas",
        activeKey: "colaboradores-control-bajas",
        requiredPermission: "partners.unsubscribe",
        icon: "user-clock",
      },
    ],
  },
  {
    name: "Calendario",
    to: "/calendar",
    activeKey: "calendar",
    requiredPermission: "applications.view",
    icon: "calendar",
  },
  {
    name: "Calendario Líder",
    to: "/leader-calendar",
    activeKey: "leader-calendar",
    requiredPermission: "calendars.leader",
    icon: "calendar-days",
  },
  {
    name: "Vacantes",
    to: "/vacantes",
    activeKey: "vacantes",
    requiredPermission: "vacancies.view",
    icon: "id-card",
  },
  {
    name: "Puestos",
    to: "/puestos",
    activeKey: "puestos",
    requiredPermission: "positions.view",
    icon: "check-to-slot",
    children: [
      {
        name: "Documentos",
        to: "/documents",
        activeKey: "documents",
        requiredPermission: "positions.view",
        icon: "file-circle-check",
      },
    ],
  },
  {
    name: "Plantillas",
    to: "/plantillas",
    activeKey: "plantillas",
    requiredPermission: "contracts.view",
    icon: "file",
  },
  {
    name: "Táctica operativa",
    to: "/tactica-operativa",
    activeKey: "tactica-operativa",
    requiredPermission: "tactical.view",
    icon: "chess",
  },
  {
    name: "Lista negra",
    to: "/lista-negra",
    activeKey: "lista-negra",
    requiredPermission: "blacklists.view",
    icon: "address-book",
  },
  // {
  //   name: "Revisión de documentos",
  //   to: "/revision-documentos",
  //   activeKey: "revision-documentos",
  //   validRoles: [
  //     "Administrador",
  //     "Administrador-",
  //     "Reclutamiento",
  //     "Reclutador",
  //     "Talento humano",
  //     "Lider de sucursal",
  //   ],
  //   icon: "file-circle-check",
  // },
  {
    name: "Usuarios",
    to: "/usuarios",
    activeKey: "usuarios",
    requiredPermission: "users.view",
    icon: "user",
  },
  {
    name: "Roles y permisos",
    to: "/roles",
    activeKey: "roles",
    requiredPermission: "roles.view",
    icon: "user-shield",
  },
  {
    name: "Expediente",
    to: "/mi-expediente",
    activeKey: "expediente",
    requiredPermission: "proceedings.view",
    icon: "folder-open",
  },
  {
    name: "Incapacidades",
    to: "/incapacidades",
    activeKey: "/incapacidades",
    requiredPermission: "incapacities.view",
    icon: "user-injured",
  },
  {
    name: "Permisos",
    to: "/permisos",
    activeKey: "/permisos",
    requiredPermission: "labor_permissions.view",
    icon: "calendar-check",
  },
  {
    name: "Vacaciones",
    to: "/vacaciones",
    activeKey: "/vacaciones",
    requiredPermission: "holidays.view",
    icon: "umbrella-beach",
  },
  {
    name: "Incidencias",
    to: "/incidencias",
    activeKey: "incidencias",
    requiredPermission: "incidents.view",
    icon: "triangle-exclamation",
  },
  {
    name: "Cumpleaños",
    to: "/sucursal/birthdates",
    activeKey: "birthdates",
    requiredPermission: "reports.birthdates",
    icon: "cake-candles",
  },
  {
    name: "Horario",
    to: "/sucursal/horario",
    activeKey: "horario",
    requiredPermission: "attendance.configure_schedule",
    icon: "calendar-check",
  },
  
  {
    name: "Reporte reloj",
    to: "/sucursal/reporte-reloj",
    activeKey: "/reporte-reloj",
    requiredPermission: "attendance.view",
    icon: "clock",
  },
  {
    name: "Horario semanal",
    to: "/sucursales/config-horario-semanal",
    activeKey: "/config-horario-semanal",
    requiredPermission: "attendance.configure_schedule",
    icon: "calendar-days",
  },
  {
    name: "Nómina",
    to: "/nomina",
    disabled: false,
    activeKey: "/nomina",
    requiredPermission: "payroll.view",
    icon: "money-bill",
    children: [
      {
        name: "Bonos",
        to: "/nomina/bonos",
        activeKey: "/nomina/bonos",
        requiredPermission: "perceptions.view",
        icon: "circle-dollar-to-slot",
      },
      {
        name: "Deducciones",
        to: "/nomina/deducciones",
        activeKey: "/nomina/deducciones",
        requiredPermission: "deductions.view",
        icon: "minus-circle",
      },
      {
        name: "Plantillas Deducciones",
        to: "/nomina/plantillas",
        activeKey: "/nomina/plantillas",
        requiredPermission: "payroll.view",
        icon: "bookmark",
      },
      {
        name: "Plantillas Bonos",
        to: "/nomina/plantillas-bonos",
        activeKey: "/nomina/plantillas-bonos",
        requiredPermission: "perceptions.view",
        icon: "bookmark",
      },
      {
        name: "Incapacidades",
        to: "/incapacidades",
        activeKey: "/incapacidades",
        requiredPermission: "payroll.view",
        icon: "user-injured",
      },
      {
        name: "Permisos",
        to: "/permisos",
        activeKey: "/permisos",
        requiredPermission: "payroll.view",
        icon: "calendar-check",
      },
      {
        name: "Vacaciones",
        to: "/vacaciones",
        activeKey: "/vacaciones",
        requiredPermission: "payroll.view",
        icon: "umbrella-beach",
      },
      {
        name: "Jefes Directos",
        to: "/direct-boss",
        activeKey: "/direct-boss",
        requiredPermission: "direct_boss.manage",
        icon: "user-tie",
      },

      {
        name: "Faltantes en caja",
        to: "/faltantes-caja",
        activeKey: "/faltantes-caja",
        requiredPermission: "payroll.view",
        icon: "money-check-dollar",
      },
      {
        name: "Préstamos",
        to: "/prestamos",
        activeKey: "/prestamos",
        requiredPermission: "payroll.view",
        icon: "hand-holding-dollar",
      },
      {
        name: "Nómina",
        to: "/nomina",
        activeKey: "/nomina",
        requiredPermission: "payroll.view",
        icon: "money-bill-wave",
      },
    ],
  },
];
